import { render, staticRenderFns } from "./GlobalNavigation.vue?vue&type=template&id=659e8719&scoped=true"
var script = {}
import style0 from "./GlobalNavigation.vue?vue&type=style&index=0&id=659e8719&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659e8719",
  null
  
)

export default component.exports